var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForbidden(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1202_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.5607 53.9959H93.6357C97.494 48.0884 96.8309 40.0913 91.6434 34.9038C85.6936 28.954 76.047 28.954 70.0972 34.9038L68.732 36.269V28.8312C68.7322 18.4311 60.3011 10 49.9009 10C39.5008 10 31.0697 18.4311 31.0697 28.8312V37.0012H27.934C14.5473 37.0012 3.69531 47.8532 3.69531 61.2399C3.69531 74.6266 14.5473 85.4786 27.934 85.4786H99.5607C108.254 85.4786 115.302 78.4311 115.302 69.7373C115.302 61.0437 108.254 53.9959 99.5607 53.9959Z",
    fill: "#EDF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5621 53.9964H93.6372C97.4955 48.0888 96.8324 40.0917 91.6448 34.9042C85.695 28.9544 76.0484 28.9544 70.0986 34.9042L68.7334 36.2694V28.8317C68.7334 18.4786 60.3779 10.08 50.043 10.0039V85.4791H99.5621C108.256 85.4791 115.303 78.4315 115.303 69.7377C115.303 61.0439 108.256 53.9964 99.5621 53.9964Z",
    fill: "#D6E8FD"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1202_33)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.6606 119.093H6.33984C1.45405 119.093 -1.59167 113.797 0.873607 109.574L35.0339 51.049C37.4745 46.8677 43.5214 46.8601 45.9664 51.049L80.1267 109.574C82.5898 113.793 79.5509 119.093 74.6606 119.093Z",
    fill: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6721 53.7578L5.5118 112.282C5.13828 112.923 5.59596 113.722 6.33841 113.722H74.6592C75.4002 113.722 75.8601 112.924 75.4858 112.282L41.3254 53.7578C40.9556 53.1243 40.0441 53.1205 39.6721 53.7578Z",
    fill: "#EE5253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5172 99.6562C42.096 99.6562 43.4298 100.97 43.4298 102.525C43.4298 104.06 42.096 105.356 40.5172 105.356C38.8923 105.356 37.5703 104.086 37.5703 102.525C37.5703 100.97 38.9198 99.6562 40.5172 99.6562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5177 95.2287C38.8835 95.2287 37.7422 94.4372 37.7422 93.304V77.3022C37.7422 76.3546 38.8575 75.3398 40.5177 75.3398C42.0145 75.3398 43.3275 76.2569 43.3275 77.3022V93.304C43.3275 94.4191 42.1459 95.2287 40.5177 95.2287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13305 109.571L38.2934 51.0466C39.1578 49.5657 40.5316 48.5351 42.1298 48.1167C39.4654 47.4192 36.537 48.4707 35.0336 51.0466L0.873277 109.571C-1.58979 113.791 1.44929 119.091 6.33951 119.091H9.59929C4.71318 119.091 1.66793 113.794 4.13305 109.571Z",
    fill: "#EE5253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.77164 112.282L42.1288 55.134L41.3254 53.7578C40.9551 53.123 40.0435 53.1218 39.6722 53.7578L5.51187 112.282C5.13819 112.923 5.59603 113.722 6.33848 113.722H9.59825C8.85707 113.722 8.39733 112.924 8.77164 112.282Z",
    fill: "#E24951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8299 102.525C40.8299 101.555 41.355 100.68 42.1375 100.158C41.6708 99.8426 41.1114 99.6562 40.5172 99.6562C38.9198 99.6562 37.5703 100.97 37.5703 102.525C37.5703 104.086 38.8923 105.356 40.5172 105.356C41.1066 105.356 41.6616 105.175 42.1261 104.869C41.3444 104.359 40.8299 103.499 40.8299 102.525Z",
    fill: "#F1F4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.002 93.304V77.3022C41.002 76.7175 41.4275 76.1081 42.1426 75.7265C41.6767 75.4863 41.1125 75.3398 40.5177 75.3398C38.8575 75.3398 37.7422 76.3546 37.7422 77.3022V93.304C37.7422 94.4372 38.8835 95.2287 40.5177 95.2287C41.1401 95.2287 41.6962 95.1097 42.147 94.9013C41.4348 94.5674 41.002 94.0007 41.002 93.304Z",
    fill: "#F1F4FC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1202_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 119,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1202_33"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    fill: "white",
    transform: "translate(0 43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbidden);
export default __webpack_public_path__ + "static/media/forbidden.0a2ab21bc3d98aad2b58f802dfd267a5.svg";
export { ForwardRef as ReactComponent };